if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    openBlockType(blockType) {
      const tabHeader = this.querySelector(`.m-tab-header[data-block-type="${blockType}"]`);
      if (!tabHeader) return false;

      const index = Number(tabHeader.dataset.index);
      if (Number.isNaN(index)) return false;

      this.tabs && this.tabs.setActiveTab(index);
      tabHeader.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

      return true;
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}

(() => {
  const productInfoSelector = 'product-info[data-section-type="product-page"]:not([data-view-mode="quick-view"])';
  const reviewRatingSelector = [
    `${productInfoSelector} .main-product__block[class*="rating"]`,
    `${productInfoSelector} .main-product__block[class*="review"]`,
    `${productInfoSelector} [id*="lai_product_reviews"]`,
    `${productInfoSelector} [id*="lai-product-reviews"]`,
    `${productInfoSelector} .scm-reviews-rate`,
    `${productInfoSelector} .jdgm-preview-badge`,
    `${productInfoSelector} .loox-rating`,
    `${productInfoSelector} .gw-rv-listing-average-placeholder`,
    `${productInfoSelector} .alr-display-review-badge`,
    `${productInfoSelector} .automizely_reviews_product_collection_star_widget`,
    `${productInfoSelector} .yotpo.bottomLine`,
    `${productInfoSelector} .stamped-product-reviews-badge`,
    `${productInfoSelector} .ryviu-collection`,
    `${productInfoSelector} .trustify-review-stars-collection`
  ].join(",");

  const scrollToElement = (element) => {
    const stickyHeader = document.querySelector(".m-header[data-sticky]:not([data-sticky='none'])");
    const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    const targetTop = element.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight - 16;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: "smooth"
    });
  };

  const openReviewsTab = (productDetailsTabs) => {
    if (typeof productDetailsTabs.openBlockType === "function") {
      return productDetailsTabs.openBlockType("reviews");
    }

    const tabHeader = productDetailsTabs.querySelector('.m-tab-header[data-block-type="reviews"]');
    if (!tabHeader) return false;

    tabHeader.click();
    tabHeader.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

    return true;
  };

  const openProductReviews = (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const rating = target && target.closest(reviewRatingSelector);
    if (!rating) return;

    const productDetailsTabs = document.querySelector("m-product-details-tabs");
    if (!productDetailsTabs || !openReviewsTab(productDetailsTabs)) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToElement(productDetailsTabs);
  };

  document.addEventListener("click", openProductReviews, true);
})();
